import { css } from 'styled-components';
import { cssByBreakpoint } from './breakpoints';
// grid-template-{row/column}s customizable
export var gridTemplateByRowOrCol = function gridTemplateByRowOrCol(type) {
  for (var _len = arguments.length, items = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    items[_key - 1] = arguments[_key];
  }

  return css(["grid-template-", "s:", ";"], type, items.map(function (item) {
    return typeof item === 'number' ? "".concat(item, "px") : item;
  }).join(' '));
};
export var gridTemplateCol = function gridTemplateCol() {
  for (var _len2 = arguments.length, columns = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    columns[_key2] = arguments[_key2];
  }

  return gridTemplateByRowOrCol.apply(void 0, ['column'].concat(columns));
};
export var gridTemplateRow = function gridTemplateRow() {
  for (var _len3 = arguments.length, rows = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
    rows[_key3] = arguments[_key3];
  }

  return gridTemplateByRowOrCol.apply(void 0, ['row'].concat(rows));
}; // grid-template-{row/column}s repeat

export var gridRepeatRowsOrCols = function gridRepeatRowsOrCols(type, num) {
  return css(["grid-template-", "s:", ";"], type, num ? "repeat(".concat(num, ", minmax(0, 1fr))") : 'none');
};
export var gridRepeatCols = function gridRepeatCols() {
  var num = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 12;
  return gridRepeatRowsOrCols('column', num);
};
export var gridRepeatRows = function gridRepeatRows() {
  var num = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
  return gridRepeatRowsOrCols('row', num);
}; // grid-auto-flow

export var gridAutoFlow = function gridAutoFlow(type, dense) {
  return css(["grid-auto-flow:", "", ";"], type, dense ? ' dense' : '');
};
export var gridAutoFlowCol = function gridAutoFlowCol() {
  var dense = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  return gridAutoFlow('column', dense);
};
export var gridAutoFlowRow = function gridAutoFlowRow() {
  var dense = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  return gridAutoFlow('row', dense);
}; // grid-auto-{row/column}s

export var gridAuto = function gridAuto(type, createdColOrRow) {
  var autoMap = {
    auto: 'auto',
    min: 'min-content',
    max: 'max-content',
    fr: 'minmax(0, 1fr)'
  };
  return css(["grid-auto-", "s:", ";"], type, autoMap[createdColOrRow]);
};
export var gridAutoCols = function gridAutoCols() {
  var createdAutoElements = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'auto';
  return gridAuto('column', createdAutoElements);
};
export var gridAutoRows = function gridAutoRows() {
  var createdAutoElements = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'auto';
  return gridAuto('row', createdAutoElements);
}; // grid-{row/column}

export var gridRowOrCol = function gridRowOrCol(type) {
  var autoOrFullMap = {
    auto: 'auto',
    full: '1 / -1'
  };

  for (var _len4 = arguments.length, items = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
    items[_key4 - 1] = arguments[_key4];
  }

  return css(["grid-", ":", ";"], type, autoOrFullMap[items[0] || 'auto'] || items.join(' / '));
};
export var gridRow = function gridRow() {
  for (var _len5 = arguments.length, items = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
    items[_key5] = arguments[_key5];
  }

  return gridRowOrCol.apply(void 0, ['row'].concat(items));
};
export var gridCol = function gridCol() {
  for (var _len6 = arguments.length, items = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
    items[_key6] = arguments[_key6];
  }

  return gridRowOrCol.apply(void 0, ['column'].concat(items));
}; // grid-{row/column} as span

export var gridRowOrColSpan = function gridRowOrColSpan(type, spanSize) {
  return css(["grid-", ":span ", " / span ", ";"], type, spanSize, spanSize);
};
export var gridRowSpan = function gridRowSpan(spanSize) {
  return gridRowOrColSpan('row', spanSize);
};
export var gridColSpan = function gridColSpan(spanSize) {
  return gridRowOrColSpan('column', spanSize);
};
export var gridColSpanByBreakpoint = function gridColSpanByBreakpoint(cols, breakpoints) {
  return cssByBreakpoint(cols.map(gridColSpan), breakpoints);
};
export var gridRowSpanByBreakpoint = function gridRowSpanByBreakpoint(cols, breakpoints) {
  return cssByBreakpoint(cols.map(gridRowSpan), breakpoints);
}; // grid-{row/column}-{start/end}

export var gridRowOrColPosition = function gridRowOrColPosition(type, position, itemWidth) {
  return css(["grid-", "-", ":", ";"], type, position, itemWidth);
};
export var gridRowStart = function gridRowStart(itemWidth) {
  return gridRowOrColPosition('row', 'start', itemWidth);
};
export var gridColStart = function gridColStart(itemWidth) {
  return gridRowOrColPosition('column', 'start', itemWidth);
};
export var gridRowEnd = function gridRowEnd(itemWidth) {
  return gridRowOrColPosition('row', 'end', itemWidth);
};
export var gridColEnd = function gridColEnd(itemWidth) {
  return gridRowOrColPosition('column', 'end', itemWidth);
};

var addPxToNumber = function addPxToNumber(value) {
  return value && typeof value === 'number' ? "".concat(value, "px") : value;
};

export var gridGap = function gridGap(value) {
  return css(["gap:", ";"], addPxToNumber(value));
};

var gridGapRowOrCol = function gridGapRowOrCol(type, value) {
  return css(["", "-gap:", ";"], type, addPxToNumber(value));
};

export var gridGapCol = function gridGapCol(value) {
  return gridGapRowOrCol('column', value);
};
export var gridGapRow = function gridGapRow(value) {
  return gridGapRowOrCol('row', value);
};
export var grid = function grid() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      numCols = _ref.numCols,
      numRows = _ref.numRows,
      gap = _ref.gap,
      columnGap = _ref.columnGap,
      rowGap = _ref.rowGap;

  return css(["display:grid;", " ", " ", " ", " ", ""], gap && gridGap(gap), columnGap && gridGapCol(columnGap), rowGap && gridGapRow(rowGap), gridRepeatCols(numCols), gridRepeatRows(numRows));
};
export var inlineGrid = function inlineGrid(params) {
  return css(["", " display:inline-grid;"], grid(params));
};